import type { BoxSummary } from "@loot-os/api-contract";
import { useMemo } from "react";

import { useFavorites } from "../../../lib/favorites.js";

/** The heart on a box tile: whether the shopper saved the box, and the press that flips it. */
export interface FavoriteToggle {
  saved: boolean;
  /** The heart's accessible name; `saved` is its pressed state. */
  label: string;
  onToggle: () => void;
}

/** A box as a card that links to its page, with the shopper's favorite toggle on it. */
export interface BoxTile {
  box: BoxSummary;
  favorite: FavoriteToggle;
}

/** `boxes` as tiles, each carrying the shopper's favorite state; null while the boxes load. */
export function useBoxTiles(boxes: BoxSummary[] | null): BoxTile[] | null {
  const { saved, toggle } = useFavorites();
  return useMemo(
    () =>
      boxes?.map((box) => ({
        box,
        favorite: {
          saved: saved.has(box.id),
          label: `Favorite ${box.name}`,
          onToggle: () => toggle(box.id),
        },
      })) ?? null,
    [boxes, saved, toggle],
  );
}
